import { post } from './client';
import { ROUTES } from './config';

export interface AuthTokens {
    user: string;
    idToken: string;
    refreshToken: string;
    expiresAt: number;
}

export interface LoginResponse {
    payload?: AuthTokens;
    data?: AuthTokens;
}

export interface RefreshResponse {
    payload?: Omit<AuthTokens, 'user'>;
    data?: Omit<AuthTokens, 'user'>;
}

export const authApi = {
    login: (email: string, password: string) =>
        post<LoginResponse>(ROUTES.LOGIN, { email, password }),
    refreshToken: (refreshToken: string) =>
        post<RefreshResponse>(ROUTES.REFRESH, { refreshToken }),
    resetPassword: (email: string) =>
        post<void>(ROUTES.RESET_PASSWORD, { email }),
};
